import {Component, EventEmitter, OnInit, Output, ViewChild, Input, AfterViewInit, ChangeDetectionStrategy} from '@angular/core';
import { FwcDatePicker } from '../../../fwc-lib.js';

// DO NOT USE THIS COMPONENT FOR NOW. USE FWC-DATE-PICKER directly

@Component({
    selector: 'sae-date-picker',
    template: ``
    // template: `<fwc-date-picker id="{{elementID}}" attr.input-label="{{label}}" (fwc-date-picker-selected)="updateSelectedDate($event)" (fwc-date-picker-error)="invalidDate()" (fwc-date-picker-blur)="blurEvent($event)" #datePicker></fwc-date-picker>
    // `
    ,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DatePickerComponent {
  // @Input() elementID: any;
  // @Input() startDate: any;
  // @Input() showDate: any = false;
  // @Input() label: any;
  // @Output() updateDate: EventEmitter<any> = new EventEmitter<any>();
  // @Output() errorOutput: EventEmitter<any> = new EventEmitter<any>();
  // @Output() blurOutput: EventEmitter<any> = new EventEmitter<any>();
  // @ViewChild('datePicker') datePickerRef;
  // selectedDate: Date | null = null;
  // dateDisplayFormat = 'MM/DD/YYYY';
  // inputDisabled = false;
  // min: Date;
  // max: Date;
  // opened = false;
  // startAt: Date | null = null;
  // startView = 'month';
  // eventType: any = '';
  //
  // fwcDatePicker: any;
  // dateRangeMin: any;
  // dateRangeMax: any;
  // disabledDate1: any;
  // disabledDate2: any;
  // today: any;
  //
  // constructor() {
  //   this.today = new Date();
  //   this.fwcDatePicker = new FwcDatePicker();
  //   this.fwcDatePicker.build();
  //   // set the dates below based on today
  //   this.dateRangeMin = new Date();
  //   this.dateRangeMax = new Date();
  //   this.disabledDate1 = new Date();
  //   this.disabledDate2 = new Date();
  //   // set min range to 1 months in the past
  //   this.dateRangeMin = this.dateRangeMin.setMonth(this.dateRangeMin.getMonth() - 1);
  //   // set max range to 3 months in the future
  //   this.dateRangeMax = this.dateRangeMax.setMonth(this.dateRangeMax.getMonth() + 3);
  //   // set some disabled date options, 10 and 20 days from today
  //   this.disabledDate1 = this.disabledDate1.setDate(this.disabledDate1.getDate() + 10);
  //   this.disabledDate2 = this.disabledDate2.setDate(this.disabledDate2.getDate() + 20);
  // }
  // ngOnInit(): void {
  // }
  // ngAfterViewInit(): void {
  //   const datePicker = document.getElementById(this.elementID);
  //   if (this.showDate) {
  //     datePicker.setAttribute('show-date', '');
  //     datePicker.setAttribute('start-date', this.startDate);
  //   }
  // }
  // updateSelectedDate(e: any): void {
  //   this.updateDate.emit(e.detail);
  // }
  // invalidDate(): void {
  //   this.errorOutput.emit(true);
  // }
  // blurEvent(e: any): void {
  //   this.blurOutput.emit(e);
  // }
}
